































import Vue from "vue";
import AbpBase from "@/lib/abpbase";
import { Component, Watch, Prop } from "vue-property-decorator";
import { GetCommunityAll } from "@/api/pdCommunity";
import { PushPatient,DistributePushPatient } from "@/api/pdReferral";
import { HubConnectionBuilder } from "@aspnet/signalr";
import { GetTeamList, GetAllUserList } from "@/api/pdTeam";

@Component({})
export default class PdDistributePushPatient extends AbpBase {
  @Prop() data: any;
  model: any = {
    patientId: 0,
    sourceCommunityName: null,
    targetTeamId: null,
    targetDoctor: null,
  };
  allTeamList: any = [];
  teamList: any = [];
  allUserList: any = [];
  doctorList: any = [];

  rules = {
    targetCommunityId: [
      {
        type: "number",
        required: true,
        message: "请选择推目标社区",
        trigger: "change"
      }
    ]
  };

  @Watch("data", { immediate: true, deep: true })
  handleDataChanged() {
    if (this.data) {
      console.log(this.data);
      this.model.patientId = this.data.id;
      this.model.sourceTeamId = this.data.teamId;
      this.model.sourceDoctor = this.data.doctor;
    }
  }

  created() {
    this.initDic();
    this.model.referralTime = this.formatDate(new Date());
    let user = this.$store.state.session.user;
    if (user) {
      this.model.referralUserName = user.name;
      this.model.sourceCommunityId = user.communityId;
      this.model.sourceCommunityName = user.communityName;
    }
  }

  async initDic() {
    let user = this.$store.state.session.user;

    let resTeam = await GetTeamList();
    this.allTeamList = resTeam.data;

    let resUser = await GetAllUserList();
    this.allUserList = resUser.data;
      this.teamList = this.allTeamList.filter(
        x => x.communityId == user.communityId
      );
  }

  handleTeamChanged() {
    if (this.model.targetTeamId) {
      this.doctorList = this.allUserList.filter(
        x => x.teamId == this.model.targetTeamId
      );
    }
  }

  async submit() {
    let validResult = false;
    this.$refs["form"].validate(async valid => {
      if (valid) {
        await DistributePushPatient(this.model);
        validResult = true;
      }
    });
    return validResult;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdReferral/pdScreening/distribute.vue